import React, { useState } from "react";
import { Link } from "react-router-dom";
import { country_data } from "../utils/countryCodes";
import { IMAGES } from "../utils/images";
import PageDesc from "../reusable/PageDesc";
import { ENROLL_BOTTOM_CONTENT } from "../utils/constants";
import "../Styles/EnrollForm.css";

const EnrollForm = () => {
  const [countryEmoji, setCountryEmoji] = useState("🇮🇳");
  const [countryCode, setcountryCode] = useState("+91");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [agreeToPrivacyPolicy, setAgreeToPrivacyPolicy] = useState(false);
  const [agreeToWhatsappUpdates, setAgreeToWhatsappUpdates] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    course: "",
    city: "",
    DoB: "",
    gender:"male",
    employmentStatus: "Employed",
    higherQualification: "",
    stream: "",
    grade: "",
    passOutYear: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    console.log(formData,name,value);
  };
  const handleCountry = (code, emoji) => {
    setCountryEmoji(emoji);
    setcountryCode(code);
    console.log(formData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!agreeToPrivacyPolicy) {
      setError("You must agree to our privacy policy");
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      
      const enrollmentData = {
        ...formData,
        countryCode,
        agreeToPrivacyPolicy,
        agreeToWhatsappUpdates
      };
      
      const response = await fetch('/api/enrollments', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(enrollmentData)
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Failed to submit enrollment');
      }
      
      console.log('Enrollment submitted successfully:', data);
      setSuccess(true);
      
      setFormData({
        name: "",
        email: "",
        mobile: "",
        course: "",
        city: "",
        DoB: "",
        gender:"",
        employmentStatus: "Employed",
        higherQualification: "",
        stream: "",
        grade: "",
        passOutYear: "",
      });
      setAgreeToPrivacyPolicy(false);
      setAgreeToWhatsappUpdates(false);
    } catch (err) {
      console.error('Enrollment submission error:', err);
      setError(err.message || 'Failed to submit enrollment. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };
  return (
    <div className="outlet-render">
      <div className="enroll-container">
        <div className="enroll-container-content">
          <h1>Enroll Now</h1>
          <p>Complete the enrollment form and begin your learning journey!</p>
        </div>

        <form className="enroll-form" onSubmit={handleSubmit}>
          <div id="input-container">
            <label id="input-label">Name *</label>
            <input
              id="input"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your Name *"
              onClick={stopPropagation}
              required
            />
          </div>
          <div id="input-container">
            <label id="input-label">Mobile number *</label>
            <div className="phonenumber-field">
              <div className="country-container">
                <span className="country-text">{countryEmoji}</span>
                <select
                  className="country-dropdown"
                  name="country-selector"
                  onChange={(e) =>
                    handleCountry(
                      JSON.parse(e.target.value).code,
                      JSON.parse(e.target.value).flag
                    )
                  }
                >
                  <option value="🇮🇳">{countryCode}</option>
                  {country_data.map((item) => (
                    <option
                      key={item.code}
                      value={JSON.stringify({
                        flag: item.flag,
                        code: item.dial_code,
                      })}
                    >
                      {item.dial_code}
                    </option>
                  ))}
                </select>
              </div>
              <input
                id="input-phone"
                type="number"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Enter Your mobile number *"
                onClick={stopPropagation}
                required
              />
            </div>
          </div>

          <div id="input-container">
            <label id="input-label">Email *</label>
            <input
              id="input"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your Email *"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container">
            <label id="input-label">Course*</label>
            <input
              id="input"
              type="text"
              name="course"
              value={formData.course}
              onChange={handleChange}
              placeholder="Course"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container">
            <label id="input-label">City*</label>
            <input
              id="input"
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="City"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container">
            <label id="input-label">Date of Birth*</label>
            <input
              id="input"
              type="date"
              name="DoB"
              value={formData.DoB}
              onChange={handleChange}
              placeholder="dd-mm-yyy"
              onClick={stopPropagation}
              required
            />
          </div>
          
          <div id="input-container">
            <label id="input-label">Gender*</label>
            <div className="gender-container">
            <input
              id="male"
              type="radio"
              name="gender"
              value="male"
              onChange={handleChange}
              onClick={stopPropagation}
              required
            />
            <label htmlFor="male">Male</label>
            
            <input
              id="female"
              type="radio"
              name="gender"
              value="female"
              onChange={handleChange}
              onClick={stopPropagation}
              required
            />
            <label htmlFor="female">Female</label>
            <input
              id="others"
              type="radio"
              name="gender"
              value="others"
              onChange={handleChange}
              onClick={stopPropagation}
              required
            />
            <label htmlFor="others">Others</label>
          </div>
          </div>

          <div id="input-container">
            <label id="input-label">Employment Status*</label>
            <select id="input" name="employmentStatus" value={formData.employmentStatus} onChange={handleChange} required>
              {/* <input
                  id="input"
                  type="text"
                  name="employment status"
                  value={formData.employmentStatus}
                  placeholder="Current Status"
                  required
                /> */}
              <img src={IMAGES.CHEVRON_DOWN} />
              <option value="Employed">Employed</option>
              <option value="Un Employed">Unemployed</option>
              <option value="Student">Student</option>
            </select>
          </div>
          <h1 className="form-subheading">Education</h1>

          <div id="input-container">
            <label id="input-label">Highest Qualification*</label>
            <input
              id="input"
              type="text"
              name="higherQualification"
              value={formData.higherQualification}
              onChange={handleChange}
              placeholder="Highest Qualification*"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container">
            <label id="input-label">Stream*</label>
            <input
              id="input"
              type="text"
              name="stream"
              value={formData.stream}
              onChange={handleChange}
              placeholder="Stream*"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container">
            <label id="input-label">Grade*</label>
            <input
              id="input"
              type="number"
              name="grade"
              value={formData.grade}
              onChange={handleChange}
              placeholder="Grade/Percentage*"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container">
            <label id="input-label">Pass out Year*</label>
            <input
              id="input"
              type="number"
              name="passOutYear"
              value={formData.passOutYear}
              onChange={handleChange}
              placeholder="Year of Pass Out*"
              onClick={stopPropagation}
              required
            />
          </div>
          <div className="check-box-container">
          <div className="check">
            <input
              type="checkbox"
              id="Accept_Privacy"
              name="agreeToPrivacyPolicy"
              checked={agreeToPrivacyPolicy}
              onChange={() => setAgreeToPrivacyPolicy(!agreeToPrivacyPolicy)}
              required
            />
            <p className="check-text">
              I agree to our <Link className="privacy"> privacy policy </Link>
            </p>
          </div>

          <div className="check">
            <input
              type="checkbox"
              id="Accept_Whatsapp"
              name="agreeToWhatsappUpdates"
              checked={agreeToWhatsappUpdates}
              onChange={() => setAgreeToWhatsappUpdates(!agreeToWhatsappUpdates)}
            />
            <p className="check-text">I agree to receive updates on Whatsapp</p>
          </div>
          </div>
          
          {error && (
            <div className="error-message" style={{ color: 'red', marginBottom: '15px' }}>
              {error}
            </div>
          )}
          
          {success && (
            <div className="success-message" style={{ color: 'green', marginBottom: '15px' }}>
              Enrollment submitted successfully! We'll contact you soon.
            </div>
          )}
          
          <button 
            type="submit" 
            className="desc-button" 
            onClick={handleSubmit} 
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Enroll Now'}
          </button>
        </form>
      </div>

      <PageDesc {...ENROLL_BOTTOM_CONTENT} />
    </div>
  );
};

export default EnrollForm;
